// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  type DefaultErrorResponse,
  DefaultErrorResponseFromJSON,
  DefaultErrorResponseToJSON,
} from "../models/DefaultErrorResponse";
import {
  type PagePublicationRead,
  PagePublicationReadFromJSON,
  PagePublicationReadToJSON,
} from "../models/PagePublicationRead";
import {
  type PublicationCreate,
  PublicationCreateFromJSON,
  PublicationCreateToJSON,
} from "../models/PublicationCreate";
import {
  type PublicationRead,
  PublicationReadFromJSON,
  PublicationReadToJSON,
} from "../models/PublicationRead";
import {
  type PublicationReadDetail,
  PublicationReadDetailFromJSON,
  PublicationReadDetailToJSON,
} from "../models/PublicationReadDetail";
import {
  type PublicationUpdate,
  PublicationUpdateFromJSON,
  PublicationUpdateToJSON,
} from "../models/PublicationUpdate";
import {
  type ValidationErrorResponse,
  ValidationErrorResponseFromJSON,
  ValidationErrorResponseToJSON,
} from "../models/ValidationErrorResponse";

export interface PublicationCreateRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  publicationCreate: PublicationCreate;
}

export interface PublicationDeleteRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  publicationId: string;
}

export interface PublicationListRequest {
  /**
   *
   */
  tenantId: string;
  /**
   * Project ID
   */
  projectId: string;
  /**
   * Page size limit
   */
  limit?: number;
  /**
   * Page offset
   */
  offset?: number;
  /**
   * Field to order by
   */
  orderBy?: PublicationListOrderByEnum;
  /**
   * Whether ordering is case-sensitive
   */
  orderByCaseSensitive?: boolean;
  /**
   * Created by
   */
  createdBy?: string | null;
  /**
   * Case-insensitive substring search on publication name
   */
  search?: string | null;
}

export interface PublicationRetrieveRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  publicationId: string;
}

export interface PublicationThumbnailRemoveRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  publicationId: string;
}

export interface PublicationThumbnailRetrieveRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  publicationId: string;
}

export interface PublicationThumbnailUploadRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  publicationId: string;
  /**
   *
   */
  imageUpload: Blob;
}

export interface PublicationUpdateRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  publicationId: string;
  /**
   *
   */
  publicationUpdate: PublicationUpdate;
}

/**
 *
 */
export class PublicationsApi extends runtime.BaseAPI {
  /**
   * Creates request options for publicationCreate without sending the request
   */
  async publicationCreateRequestOpts(
    requestParameters: PublicationCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling publicationCreate().'
      );
    }

    if (requestParameters["publicationCreate"] == null) {
      throw new runtime.RequiredError(
        "publicationCreate",
        'Required parameter "publicationCreate" was null or undefined when calling publicationCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_write",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " +
        btoa((this.configuration.username || "") + ":" + (this.configuration.password || ""));
    }

    let urlPath = `/tenants/{tenant_id}/publications`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: PublicationCreateToJSON(requestParameters["publicationCreate"]),
    };
  }

  /**
   * Create a new publication.
   * create publication
   */
  async publicationCreateRaw(
    requestParameters: PublicationCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PublicationRead>> {
    const requestOptions = await this.publicationCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PublicationReadFromJSON(jsonValue));
  }

  /**
   * Create a new publication.
   * create publication
   */
  async publicationCreate(
    requestParameters: PublicationCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PublicationRead> {
    const response = await this.publicationCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for publicationDelete without sending the request
   */
  async publicationDeleteRequestOpts(
    requestParameters: PublicationDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling publicationDelete().'
      );
    }

    if (requestParameters["publicationId"] == null) {
      throw new runtime.RequiredError(
        "publicationId",
        'Required parameter "publicationId" was null or undefined when calling publicationDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "publication_manage",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " +
        btoa((this.configuration.username || "") + ":" + (this.configuration.password || ""));
    }

    let urlPath = `/tenants/{tenant_id}/publications/{publication_id}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{publication_id}",
      encodeURIComponent(String(requestParameters["publicationId"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Delete a publication.
   * delete publication
   */
  async publicationDeleteRaw(
    requestParameters: PublicationDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.publicationDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete a publication.
   * delete publication
   */
  async publicationDelete(
    requestParameters: PublicationDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.publicationDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for publicationList without sending the request
   */
  async publicationListRequestOpts(
    requestParameters: PublicationListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling publicationList().'
      );
    }

    if (requestParameters["projectId"] == null) {
      throw new runtime.RequiredError(
        "projectId",
        'Required parameter "projectId" was null or undefined when calling publicationList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    if (requestParameters["orderBy"] != null) {
      queryParameters["order_by"] = requestParameters["orderBy"];
    }

    if (requestParameters["orderByCaseSensitive"] != null) {
      queryParameters["order_by_case_sensitive"] = requestParameters["orderByCaseSensitive"];
    }

    if (requestParameters["projectId"] != null) {
      queryParameters["project_id"] = requestParameters["projectId"];
    }

    if (requestParameters["createdBy"] != null) {
      queryParameters["created_by"] = requestParameters["createdBy"];
    }

    if (requestParameters["search"] != null) {
      queryParameters["search"] = requestParameters["search"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_read",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " +
        btoa((this.configuration.username || "") + ":" + (this.configuration.password || ""));
    }

    let urlPath = `/tenants/{tenant_id}/publications`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Return a list of publications for a specific project.
   * list publications
   */
  async publicationListRaw(
    requestParameters: PublicationListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PagePublicationRead>> {
    const requestOptions = await this.publicationListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PagePublicationReadFromJSON(jsonValue)
    );
  }

  /**
   * Return a list of publications for a specific project.
   * list publications
   */
  async publicationList(
    requestParameters: PublicationListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PagePublicationRead> {
    const response = await this.publicationListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for publicationRetrieve without sending the request
   */
  async publicationRetrieveRequestOpts(
    requestParameters: PublicationRetrieveRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling publicationRetrieve().'
      );
    }

    if (requestParameters["publicationId"] == null) {
      throw new runtime.RequiredError(
        "publicationId",
        'Required parameter "publicationId" was null or undefined when calling publicationRetrieve().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "publication_read",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " +
        btoa((this.configuration.username || "") + ":" + (this.configuration.password || ""));
    }

    let urlPath = `/tenants/{tenant_id}/publications/{publication_id}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{publication_id}",
      encodeURIComponent(String(requestParameters["publicationId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Return detailed information of an individual publication.
   * show publication details
   */
  async publicationRetrieveRaw(
    requestParameters: PublicationRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PublicationReadDetail>> {
    const requestOptions = await this.publicationRetrieveRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PublicationReadDetailFromJSON(jsonValue)
    );
  }

  /**
   * Return detailed information of an individual publication.
   * show publication details
   */
  async publicationRetrieve(
    requestParameters: PublicationRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PublicationReadDetail> {
    const response = await this.publicationRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for publicationThumbnailRemove without sending the request
   */
  async publicationThumbnailRemoveRequestOpts(
    requestParameters: PublicationThumbnailRemoveRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling publicationThumbnailRemove().'
      );
    }

    if (requestParameters["publicationId"] == null) {
      throw new runtime.RequiredError(
        "publicationId",
        'Required parameter "publicationId" was null or undefined when calling publicationThumbnailRemove().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "publication_manage",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " +
        btoa((this.configuration.username || "") + ":" + (this.configuration.password || ""));
    }

    let urlPath = `/tenants/{tenant_id}/publications/{publication_id}/thumbnail`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{publication_id}",
      encodeURIComponent(String(requestParameters["publicationId"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Remove a publication thumbnail image.
   * Remove publication thumbnail
   */
  async publicationThumbnailRemoveRaw(
    requestParameters: PublicationThumbnailRemoveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.publicationThumbnailRemoveRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Remove a publication thumbnail image.
   * Remove publication thumbnail
   */
  async publicationThumbnailRemove(
    requestParameters: PublicationThumbnailRemoveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.publicationThumbnailRemoveRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for publicationThumbnailRetrieve without sending the request
   */
  async publicationThumbnailRetrieveRequestOpts(
    requestParameters: PublicationThumbnailRetrieveRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling publicationThumbnailRetrieve().'
      );
    }

    if (requestParameters["publicationId"] == null) {
      throw new runtime.RequiredError(
        "publicationId",
        'Required parameter "publicationId" was null or undefined when calling publicationThumbnailRetrieve().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "publication_read",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " +
        btoa((this.configuration.username || "") + ":" + (this.configuration.password || ""));
    }

    let urlPath = `/tenants/{tenant_id}/publications/{publication_id}/thumbnail`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{publication_id}",
      encodeURIComponent(String(requestParameters["publicationId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Retrieve the thumbnail image of a publication.
   * Get publication thumbnail
   */
  async publicationThumbnailRetrieveRaw(
    requestParameters: PublicationThumbnailRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<runtime.HttpFile>> {
    const requestOptions = await this.publicationThumbnailRetrieveRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.BlobApiResponse(response);
  }

  /**
   * Retrieve the thumbnail image of a publication.
   * Get publication thumbnail
   */
  async publicationThumbnailRetrieve(
    requestParameters: PublicationThumbnailRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.HttpFile | null | undefined> {
    const response = await this.publicationThumbnailRetrieveRaw(requestParameters, initOverrides);
    switch (response.raw.status) {
      case 200:
        return await response.value();
      case 204:
        return null;
      default:
        return await response.value();
    }
  }

  /**
   * Creates request options for publicationThumbnailUpload without sending the request
   */
  async publicationThumbnailUploadRequestOpts(
    requestParameters: PublicationThumbnailUploadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling publicationThumbnailUpload().'
      );
    }

    if (requestParameters["publicationId"] == null) {
      throw new runtime.RequiredError(
        "publicationId",
        'Required parameter "publicationId" was null or undefined when calling publicationThumbnailUpload().'
      );
    }

    if (requestParameters["imageUpload"] == null) {
      throw new runtime.RequiredError(
        "imageUpload",
        'Required parameter "imageUpload" was null or undefined when calling publicationThumbnailUpload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "publication_manage",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " +
        btoa((this.configuration.username || "") + ":" + (this.configuration.password || ""));
    }
    const consumes: runtime.Consume[] = [{ contentType: "multipart/form-data" }];
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes);

    let formParams: { append(param: string, value: any): any };
    let useForm = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new URLSearchParams();
    }

    if (requestParameters["imageUpload"] != null) {
      formParams.append("image_upload", requestParameters["imageUpload"] as any);
    }

    let urlPath = `/tenants/{tenant_id}/publications/{publication_id}/thumbnail`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{publication_id}",
      encodeURIComponent(String(requestParameters["publicationId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: formParams,
    };
  }

  /**
   * Upload and replace a publication thumbnail image.
   * Upload publication thumbnail
   */
  async publicationThumbnailUploadRaw(
    requestParameters: PublicationThumbnailUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<runtime.HttpFile>> {
    const requestOptions = await this.publicationThumbnailUploadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.BlobApiResponse(response);
  }

  /**
   * Upload and replace a publication thumbnail image.
   * Upload publication thumbnail
   */
  async publicationThumbnailUpload(
    requestParameters: PublicationThumbnailUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.HttpFile | null | undefined> {
    const response = await this.publicationThumbnailUploadRaw(requestParameters, initOverrides);
    switch (response.raw.status) {
      case 200:
        return await response.value();
      case 204:
        return null;
      default:
        return await response.value();
    }
  }

  /**
   * Creates request options for publicationUpdate without sending the request
   */
  async publicationUpdateRequestOpts(
    requestParameters: PublicationUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling publicationUpdate().'
      );
    }

    if (requestParameters["publicationId"] == null) {
      throw new runtime.RequiredError(
        "publicationId",
        'Required parameter "publicationId" was null or undefined when calling publicationUpdate().'
      );
    }

    if (requestParameters["publicationUpdate"] == null) {
      throw new runtime.RequiredError(
        "publicationUpdate",
        'Required parameter "publicationUpdate" was null or undefined when calling publicationUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "publication_manage",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " +
        btoa((this.configuration.username || "") + ":" + (this.configuration.password || ""));
    }

    let urlPath = `/tenants/{tenant_id}/publications/{publication_id}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{publication_id}",
      encodeURIComponent(String(requestParameters["publicationId"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PublicationUpdateToJSON(requestParameters["publicationUpdate"]),
    };
  }

  /**
   * Update a publication.
   * update publication
   */
  async publicationUpdateRaw(
    requestParameters: PublicationUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PublicationRead>> {
    const requestOptions = await this.publicationUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PublicationReadFromJSON(jsonValue));
  }

  /**
   * Update a publication.
   * update publication
   */
  async publicationUpdate(
    requestParameters: PublicationUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PublicationRead | null | undefined> {
    const response = await this.publicationUpdateRaw(requestParameters, initOverrides);
    switch (response.raw.status) {
      case 200:
        return await response.value();
      case 204:
        return null;
      default:
        return await response.value();
    }
  }
}

/**
 * @export
 */
export const PublicationListOrderByEnum = {
  CreatedAt: "created_at",
  CreatedAt2: "-created_at",
  UpdatedAt: "updated_at",
  UpdatedAt2: "-updated_at",
} as const;
export type PublicationListOrderByEnum =
  (typeof PublicationListOrderByEnum)[keyof typeof PublicationListOrderByEnum];
